import { createDeepEqualSelector, RootState } from '@/store/store';
import { EXCHANGES } from '@/lib/types/generalTypes';
import { InitialExchanges, Pull, PullStatus } from './exchangesSliceTypes';

export type ExchangesList = {
    visibleName: string;
    accountsNumber: number;
    logo: any;
    id: EXCHANGES;
    favNumber: number;
};

// SELECTORS

const exchangesSelector = (state: RootState): InitialExchanges => state.exchanges;
export const pullSelector = (state: RootState) => state.exchanges.pullStatus;

// SELECTS

export const selectPullStatusByAccountId = createDeepEqualSelector(
    [pullSelector, (state, { accountId }: { accountId: number }) => accountId],
    (pullStatus: PullStatus, accountId) => {
        const pull: Pull = pullStatus?.[accountId] || null;
        return pull;
    },
);

export const selectMultiplePullStatusByAccountId = createDeepEqualSelector(
    [pullSelector, (state, { accountIds }: { accountIds: number[] }) => accountIds],
    (pullStatus: PullStatus, accountIds) => {
        return accountIds.map((accountId) => pullStatus?.[accountId]?.status || null);
    },
);

export const selectPullForAllExchanges = createDeepEqualSelector(
    [exchangesSelector],
    (exchangesState) => exchangesState.pullStatus,
);

export const selectIsRefreshError = createDeepEqualSelector(
    [exchangesSelector],
    (exchanges) => exchanges.isRefreshError,
);
